import { take, takeUntil } from "rxjs/operators";
import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
} from "@angular/core";
import { DateService } from "../../_services/date.service";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "../../_services/authentication.service";
import { Subject } from "rxjs";

@Component({
  selector: "app-login-page",
  templateUrl: "./login-page.component.html",
  styleUrls: ["./login-page.component.scss"],
})
export class LoginPageComponent implements OnInit, OnDestroy {
  today: number = Date.now();
  src: string = "";
  loginForm: FormGroup;
  submitted = false;
  loading = false;
  returnUrl: string;
  error = null;
  message: string = "";
  isLoggedIn = false;
  private subscription = new Subject();
  /**
   * @description constructor
   * @param authenticationService
   * @param formBuilder
   * @param route
   * @param router
   * @param alert
   */
  constructor(
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public dateService: DateService
  ) {}

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || "/";
    this.authenticationService.currentUser$
      .pipe(takeUntil(this.subscription))
      .subscribe((user) => {
        if (user) {
          const country = user.country;
          if (country.toLowerCase() === "uganda") {
            this.router.navigateByUrl("/mobile-dashboard");
          } else if (country.toLowerCase() === "india") {
            this.router.navigateByUrl("/india-dashboard");
          }
        }
      });
    this.loginForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required]],
    });
  }

  ngOnDestroy() {
    this.subscription.next();
    this.subscription.complete();
  }

  clearMessage() {
    this.error = "";
  }

  handleSubmit(formData: any) {
    this.submitted = true;
    if (this.loginForm.valid) {
      this.login();
    }
    return;
  }

  login() {
    this.loading = true;
    this.clearMessage();
    this.authenticationService.loginUser(this.loginForm.value).subscribe(
      (res) => {
        this.loading = false;
        this.authenticationService.setCurrentUserValue({
          ...res.user,
          token: res.token,
        });
      },
      (res) => {
        this.loading = false;
        this.error = res.error.message;
      }
    );
  }
}
